export function copy(str: string) {
  return navigator.clipboard.writeText(str);
}
